export default __webpack_public_path__ + "../staticImages/winefinder-sprite-match-with-09-2x.png";